module.exports = __webpack_public_path__ + "static/media/pizza_cf.448ef5f9.png";